/*
  react-app-botech-context
*/

import makeApiCall from './makeApiCall';

// Contains default values for the Botech context in the react standalone app.
const botech = {
  
  // Older properties.
  makeApiCall,
  userId: null,
  modelId: null,
  apiUrl: process.env.REACT_APP_API_URL,

  // Properties.
  readOnly: false,
  initialModel: null,
  saveModel: null,
  runModel: null,
  runModelExtraFormComponent: null,

};

export default botech;
